// @flow

export function getClientId(): string {
  if (!window.ga) {
    throw new GaNotAvailable();
  }

  const all = window.ga.getAll();
  if (!all || all.length !== 1) {
    throw new GaGetAllInvalidReturn();
  }

  const clientId = all[0].get('clientId');
  if (!clientId) {
    throw new GaClientIdNotDefined();
  }

  return clientId;
}

export class GaError extends Error {
}

export class GaNotAvailable extends GaError {
  constructor() {
    super('Google Analytics (window.ga) not avaiable');
  }
}

export class GaGetAllInvalidReturn extends GaError {
  constructor(data: any) {
    super('window.ga.getAll() returned invalid data: ' + data);
  }
}

export class GaClientIdNotDefined extends GaError {
  constructor() {
    super('window.ga.clientId is not defined');
  }
}
